import React from 'react';
import { Box } from '@mui/material';
import RequireRoles from 'components/common/requireRole';
import SettingsSection from './SettingsSection';
import {
  dangerZoneNavItems,
  dataImportNavItems,
  otherNavItems,
  outreachNavItems,
  profileNavItems,
  templatesNavItems,
  workplaceNavItems,
} from './settingsHomeNavItems';

const SettingsHomeContent = () => {
  return (
    <Box data-testid="@settings">
      <SettingsSection title="Profile" items={profileNavItems()} />

      <SettingsSection title="Outreach" items={outreachNavItems()} />

      <SettingsSection title="Templates" items={templatesNavItems()} />

      <SettingsSection title="Workplace" items={workplaceNavItems()} />

      <RequireRoles roles={['superAdmin', 'admin']}>
        <SettingsSection title="Data Import" items={dataImportNavItems()} />
      </RequireRoles>

      <SettingsSection title="Other" items={otherNavItems()} />

      <RequireRoles roles={['superAdmin', 'admin']}>
        <SettingsSection title="Danger Zone" items={dangerZoneNavItems()} isDanger />
      </RequireRoles>
    </Box>
  );
};

export default SettingsHomeContent;
